import clsx from 'clsx'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline'

interface EmptyStateProps {
  message?: string
  className?: string
}
export const EmptyState = ({
  message = 'No results found',
  className,
}: EmptyStateProps) => {
  return (
    <div
      className={clsx(
        'flex w-full flex-col items-center justify-center gap-2 py-4 text-gray-500',
        className
      )}
    >
      <QuestionMarkCircleIcon className="w-8" />
      <p className="text-sm">{message}</p>
    </div>
  )
}
